import React from "react";
import ToggleBar from "../../commoncomponents/toggleBar";
import { Table } from "react-bootstrap";
import { utcToLocal } from "../../../utils/dateConvert";
import { rounding, getFriendlyHeading } from "../../../utils/math";
import Location from '../../commoncomponents/location';
import ShowIButtonName from "../../commoncomponents/showIButtonName";
import { downloadCSVFile } from "../../../api/apiClient";
import { formatTemperatureReading, getValidTemperature, temperatureReadingClass } from "../../../utils/temperature";

function TrackLog(props) {
  const renderFridge = (value) => {
    const isOn = value === true || value === 1 || value === "1";

    return (
      <span className={`fridge-pill ${isOn ? "fridge-on" : "fridge-off"}`}>
        <i className="fa fa-snowflake-o" />
        {isOn ? "On" : "Off"}
      </span>
    );
  };

  const renderDoorSensor = (value) => {
    const isClosed = value === true || value === 1 || value === "1" || value === "Closed";

    return (
      <span className={`door-sensor-pill ${isClosed ? "door-sensor-closed" : "door-sensor-open"}`}>
        {isClosed ? "Closed" : "Open"}
      </span>
    );
  };

  const renderIgnition = (value) => {
    const isDriving = value === true || value === 1 || value === "1";

    return (
      <span className={isDriving ? "engine-driving" : "engine-park"} title={isDriving ? "Driving" : "Parked"}>
        {isDriving ? "D" : "P"}
      </span>
    );
  };

  const renderGps = (value) => {
    const isLocked = value === "A" || value === true || value === 1 || value === "1";

    return (
      <i
        className={isLocked ? "fa fa-globe text-normal" : "fa fa-globe text-danger"}
        style={isLocked ? { color: "green" } : undefined}
        title={isLocked ? "Lock" : "No Lock"}
      />
    );
  };

  const getGpsStatus = (value) => {
    return value === "A" || value === true || value === 1 || value === "1" ? "Lock" : "No Lock";
  };

  const handleDownloadExcel = () => {
    const csvData = props.trackDataTotal.map((data) => {
      const lastMessage = data.lastMessage || {};
      const gPRMC = lastMessage.gPRMC || {};
      const row = {
        Created: utcToLocal(lastMessage.created),
        "Friendly Name": data.friendlyName,
        Name: data.assetName,
        Location: lastMessage.location,
        LogID: lastMessage.messageID,
        Ignition: lastMessage.iO8 == 1 ? "Driving" : "Parked",
        Speed: rounding(gPRMC.speed),
        GPS: getGpsStatus(gPRMC.validity),
        Direction: getFriendlyHeading(gPRMC.heading),
        Fridge: lastMessage.iO1 == 1 ? "On" : "Off",
      };

      if (props.tempAEnabled) row["Temp A"] = getValidTemperature(lastMessage.sensorAValue);
      if (props.tempBEnabled) row["Temp B"] = getValidTemperature(lastMessage.sensorBValue);
      if (props.doorSensorEnabled) row["Door Sensor"] = lastMessage.iO2 == 1 ? "Closed" : "Open";

      return row;
    });

    const latest = props.trackDataTotal[0] || {};
    downloadCSVFile(csvData, "Track_Logs", latest.assetName, localStorage.getItem("timeZoneID"), latest.assetId);
  };

  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>Created</th>
          <th>Friendly Name</th>
          <th>Name</th>
          <th>Location</th>
          <th>LogID</th>
          <th>Ignition</th>
          <th>Speed</th>
          <th>GPS</th>
          <th>Direction</th>
          <th>Fridge</th>
          {props.tempAEnabled && <th>Temp A</th>}
          {props.tempBEnabled && <th>Temp B</th>}
          {props.doorSensorEnabled && <th>Door Sensor</th>}
        </tr>
      </thead>
      <tbody>
        {props.trackDataTotal.length > 0 && props.trackDataTotal.map((data, index) => {
          let lastMessage = data.lastMessage || {};
          let gPRMC = lastMessage.gPRMC || {};

          return (
            <tr>
              <td>{utcToLocal(lastMessage.created)}</td>
              <td>{data.friendlyName}</td>
              <td>{data.assetName}
              <br />
              <ShowIButtonName 
                  ibuttonId={data.ibuttonId}
                  serialno={data.serialno} 
                  iButtonName={data.iButtonName}
                />
                </td>
              <td>
                <Location
                  address={lastMessage.location}
                  lat={gPRMC.latitude}
                  lng={gPRMC.longitude}
                />
              </td>
              <td>{lastMessage.messageID}</td>
              <td>{renderIgnition(lastMessage.iO8)}</td>
              <td>{rounding(gPRMC.speed)}</td>
              <td>{renderGps(gPRMC.validity)}</td>
              <td>{getFriendlyHeading(gPRMC.heading)}</td>
              <td>{renderFridge(lastMessage.iO1)}</td>
              {props.tempAEnabled && <td className={temperatureReadingClass(lastMessage.sensorAValue)}>{formatTemperatureReading(lastMessage.sensorAValue)}</td>}
              {props.tempBEnabled && <td className={temperatureReadingClass(lastMessage.sensorBValue)}>{formatTemperatureReading(lastMessage.sensorBValue)}</td>}
              {props.doorSensorEnabled && <td>{renderDoorSensor(lastMessage.iO2)}</td>}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );

  return (
    <ToggleBar
      caption="Logs"
      download={handleDownloadExcel}
      icon="fa-building"
      color="#337ab7"
      content={data}
    />
  );
}

export default TrackLog;
